import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'nameInitials',
})
export class NameInitialsPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(userName: string): string {
    const name = userName?.trim() || '';
    const names = name.split(' ');
    if (names.length > 1) {
      // uses the full name to create initials
      return [names[0], names[names.length - 1]].join(' ');
    } else if (name.length > 1) {
      // uses the first and second letter of the name to create initials
      return name[0] + ' ' + name[1];
    } else if (name.length === 1) {
      // uses the given name to create initials
      return name;
    } else {
      // no name provided, uses `Fulfillment Agent`
      return this.translateService.instant('COMMENT.FULFILLMENT_AGENT');
    }
  }
}
